export const common = {
  nav: {
    home: 'Home',
    about: 'About Us',
    training: 'Training',
    give: 'Give',
    contact: 'Contact',
  },
  hero: {
    title: 'Raising a Generation',
    subtitle: 'Empowering worshipers and leaders to transform the world through authentic worship and the presence of God',
    watchBtn: 'Watch',
    joinBtn: 'Join AID',
  },
  about: {
    badge: 'About Us',
    title: 'Raising Worshipers and Leaders',
    intro: 'AID Worship means "Amen in the Dark." We are an artistic family who choose to say Amen in a dark world, worshiping the Lord and walking faithfully with Him.',
    paragraph1: 'We help the next generation grow in God\'s presence and become worshipers and leaders who impact their generation. Through worship-centered gatherings, we lead people into deeper encounters with God.',
    paragraph2: 'Through our Next Generation ministry, we help individuals discover their God-given identity, gifts, and calling, encouraging them to use their creativity, musical abilities, leadership potential, and spiritual gifts.',
    paragraph3: 'By creating worship content—songs, arrangements, recordings, and media—we develop musical skills and help them steward their gifts with purpose and express their faith through worship.',
    paragraph4: 'Through mentoring and training, we walk alongside them so they grow strong in God\'s presence, grounded in His Word, and confident in their calling.',
    learnMoreBtn: 'Learn More About Our Mission',
  },
  training: {
    badge: 'Training',
    title: 'Equipping Worshipers and Leaders',
    subtitle: 'A discipleship program to raise worshipers and leaders who will experience God\'s presence and transform nations',
    program1Title: 'Worship Leader Training',
    program1Desc: 'Professional training to develop both calling and skills as a worship leader',
    program2Title: 'Biblical Foundation',
    program2Desc: 'Deep learning of the essence and theology of worship on a biblical basis',
    program3Title: 'Worship Content Creation',
    program3Desc: 'Creating worship content through music and creativity',
    program4Title: 'Spiritual Formation',
    program4Desc: 'Journey of spiritual maturity in intimate relationship with God',
    comingSoonTitle: '2026 Training Program Coming Soon',
    comingSoonSubtitle: 'Join us on a journey to raise next generation worshipers and leaders',
    comingSoonBtn: 'Coming Soon',
  },
  give: {
    badge: 'Give',
    title: 'Be Part of Our Journey',
    subtitle: 'Your support helps raise the next generation of worshipers and leaders who will transform the world',
    impactArea1Title: 'Youth Ministry',
    impactArea1Desc: 'Supporting programs that nurture young worshipers and help them discover their calling',
    impactArea2Title: 'Leadership Training',
    impactArea2Desc: 'Equipping emerging leaders with biblical foundation and practical ministry skills',
    impactArea3Title: 'Mission Work',
    impactArea3Desc: 'Expanding our reach to raise worshipers and leaders across nations',
    impactNote: '100% of your donation goes directly to ministry',
    impactNoteDesc: 'Every dollar you give helps raise the next generation of worshipers and leaders',
    donateBtn: 'Donate Now',
    partnerBtn: 'Become a Partner',
    modalTitle: 'Make a Donation',
    selectAmount: 'Choose Amount',
    customAmount: 'Custom Amount',
    donorName: 'Full Name',
    donorNamePlaceholder: 'Your Name (Optional)',
    donorEmail: 'Email',
    donorEmailPlaceholder: 'your@email.com',
    message: 'Message',
    messagePlaceholder: 'Share your heart with us (Optional)',
    donateButton: 'Donate $',
    processing: 'Processing...',
    paypalNote: 'You will be redirected to PayPal to complete your donation securely',
    successTitle: 'Thank You!',
    successMessage: 'Your donation has been received',
    bankTransferTitle: 'Bank Transfer',
    bankName: 'KB Bank, Korea',
    accountNumber: 'Account Number',
    accountHolder: 'Account Holder',
    paypalTitle: 'PayPal',
    paypalDesc: 'Donate easily and securely via PayPal',
  },
  contact: {
    badge: 'Contact Us',
    title: 'Let\'s Connect',
    subtitle: 'Have questions or want to know more? We\'re here to help',
    namePlaceholder: 'Your Name',
    emailPlaceholder: 'Your Email',
    messagePlaceholder: 'Your Message',
    sendBtn: 'Send Message',
    sending: 'Sending...',
    success: 'Your message has been sent successfully!',
    error: 'Failed to send message. Please try again.',
  },
  footer: {
    description: 'Raising worshipers and leaders to transform the world through authentic worship and the presence of God',
    quickLinks: 'Quick Links',
    connect: 'Connect',
    rights: 'All rights reserved',
  },
};